export const Cancel: React.FC<React.SVGProps<SVGSVGElement>> = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 7.414 7.414">
        <g id="cancel_boundaryless_v1_1X" transform="translate(0.707 0.707)">
            <line id="Line_215" data-name="Line 215" x2="6" y2="6" fill="none" strokeLinecap="round" strokeWidth="1" />
            <line id="Line_214" data-name="Line 214" x2="6" y2="6" transform="translate(6) rotate(90)" fill="none" strokeLinecap="round" strokeWidth="1" />
        </g>
    </svg>
);
